module.exports = __webpack_public_path__ + "img/img047.f54a7fa6.png";